import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'

// Landing page for users who just got signed out because their
// user_profiles.deactivated_at was set. Replaces the silent sign-out
// loop where users ended up on /login with no explanation — typically
// causing a password-reset attempt that can't succeed because the
// reactivated state isn't the fix.
//
// AuthProvider writes sessionStorage['placed:deactivated'] = '1'
// right before calling signOut(). ProtectedRoute reads it on re-render
// and routes here. This page clears the flag on unmount so a refresh
// sends them back to /login like normal.

export default function DeactivatedPage() {
  useEffect(() => {
    return () => {
      try { sessionStorage.removeItem('placed:deactivated') } catch { /* noop */ }
    }
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: 'linear-gradient(180deg, #fef9f0 0%, #f2ede4 100%)' }}>
      <div className="max-w-md text-center">
        <div className="w-14 h-14 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ background: '#fde0e0' }}>
          <AlertTriangle size={26} style={{ color: '#ba1a1a' }} />
        </div>
        <h1 className="text-2xl font-bold tracking-[0.02em] mb-2" style={{ color: '#1d1c16' }}>
          Account Deactivated
        </h1>
        <p className="text-sm mb-6" style={{ color: '#4a4740' }}>
          This account has been deactivated by your organization admin. If you believe this is a mistake, please contact them directly — resetting your password won't restore access.
        </p>
        <Link
          to="/login"
          className="inline-block px-5 py-2.5 rounded-md text-sm font-semibold"
          style={{ background: '#004b4b', color: '#ffffff' }}
        >
          Sign in with a different account
        </Link>
      </div>
    </div>
  )
}
